export const SET_SERVICES = 'Set services'
export const DELETE_SERVICE = 'Delete services'
export const UPDATE_SERVICE = 'Update services'
export const ADD_SERVICE_DATA = 'Add service data'
export const SET_SERVICE_DATA = 'Set service data'

// wards
export const SET_WARDS = 'Set wards'